/**
 * Action types for Profile Information management
 */

export const FETCH_USER_PROFILE_REQUEST =
  "profileInformation/FETCH_USER_PROFILE_REQUEST" as const;
export const FETCH_USER_PROFILE_SUCCESS =
  "profileInformation/FETCH_USER_PROFILE_SUCCESS" as const;
export const FETCH_USER_PROFILE_FAILURE =
  "profileInformation/FETCH_USER_PROFILE_FAILURE" as const;

export const UPDATE_USER_PROFILE_REQUEST =
  "profileInformation/UPDATE_USER_PROFILE_REQUEST" as const;
export const UPDATE_USER_PROFILE_SUCCESS =
  "profileInformation/UPDATE_USER_PROFILE_SUCCESS" as const;
export const UPDATE_USER_PROFILE_FAILURE =
  "profileInformation/UPDATE_USER_PROFILE_FAILURE" as const;

export const RESET_PROFILE_STATE =
  "profileInformation/RESET_PROFILE_STATE" as const;

export const FETCH_AVATAR_REQUEST =
  "profileInformation/FETCH_AVATAR_REQUEST" as const;

export const FETCH_AVATAR_SUCCESS =
  "profileInformation/FETCH_AVATAR_SUCCESS" as const;

export const FETCH_AVATAR_FAILURE =
  "profileInformation/FETCH_AVATAR_FAILURE" as const;

export const UPLOAD_AVATAR_REQUEST =
  "profileInformation/UPLOAD_AVATAR_REQUEST" as const;

export const UPLOAD_AVATAR_SUCCESS =
  "profileInformation/UPLOAD_AVATAR_SUCCESS" as const;

export const UPLOAD_AVATAR_FAILURE =
  "profileInformation/UPLOAD_AVATAR_FAILURE" as const;

